import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from 'react-router-dom';


const QUESTIONNAIRES_CONFIG = [
  { key: 'valeurs', path: '/questionnaires/mes-valeurs', icon: '💜', label: 'Questionnaire Mes valeurs', duration: '5 min' },
  { key: 'interets', path: '/questionnaires/mes-interets', icon: '🧭', label: 'Questionnaire Mes intérêts', duration: '5 min' },
  { key: 'energies', path: '/questionnaires/mes-energies', icon: '⚡', label: 'Questionnaire Mes énergies', duration: '5 min' },
  { key: 'intelligences', path: '/questionnaires/mes-intelligences', icon: '🧩', label: 'Questionnaire Mes intelligences', duration: '5 min' },
];

export default function CompleteProfileModal({ isOpen, onClose }) {
  if (!isOpen) return null;
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  // Valeurs arbitraires pour les questionnaires (à dynamiser plus tard)
  const questionnaires = {
    valeurs: user.values_survey,
    interets: user.riasec_survey,
    energies: user.jourda_survey,
    intelligences: user.im_survey
  };
  const completedCount = Object.values(questionnaires).filter(Boolean).length;

  // Questionnaires manquants
  const missingQuestionnaires = QUESTIONNAIRES_CONFIG.filter(q => !questionnaires[q.key]);

  const handleStartQuestionnaire = (path) => {
    navigate(path)
    onClose();
  };

  return (
    <div
      className="absolute inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-slate-900 rounded-2xl p-6 max-w-sm w-full border border-slate-700"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Titre avec icône */}
        <div className="text-center mb-4">
          <span className="text-4xl mb-3 block">✨</span>
          <h2 className="text-white text-xl font-bold mb-2">
            Analyse personnalisée
          </h2>
          <p className="text-gray-400 text-sm">
            Complète tes 4 questionnaires pour découvrir si ce métier te correspond.
          </p>
        </div>

        {/* Progression */}
        <div className="flex items-center justify-center gap-2 mb-5">
          <div className={`w-3 h-3 rounded-full ${questionnaires.valeurs ? 'bg-purple-500' : 'bg-slate-600'}`}></div>
          <div className={`w-3 h-3 rounded-full ${questionnaires.interets ? 'bg-blue-500' : 'bg-slate-600'}`}></div>
          <div className={`w-3 h-3 rounded-full ${questionnaires.energies ? 'bg-orange-500' : 'bg-slate-600'}`}></div>
          <div className={`w-3 h-3 rounded-full ${questionnaires.intelligences ? 'bg-green-500' : 'bg-slate-600'}`}></div>
          <span className="text-gray-500 text-sm ml-2">
            {completedCount}/4
          </span>
        </div>

        {/* Liste des questionnaires manquants */}
        <div className="space-y-2 mb-5">
          <p className="text-gray-500 text-xs uppercase tracking-wide mb-2">Il te manque :</p>
          {missingQuestionnaires.map((q) => (
            <button
              key={q.key}
              onClick={() => handleStartQuestionnaire(q.path)}
              className="w-full text-left p-3 bg-slate-800 hover:bg-slate-750 rounded-xl border border-slate-700 hover:border-emerald-500/50 transition-all group"
            >
              <div className="flex items-center gap-3">
                <span className="text-xl">{q.icon}</span>
                <div className="flex-1">
                  <p className="text-white text-sm font-medium group-hover:text-emerald-400 transition-colors">
                    {q.label}
                  </p>
                  <p className="text-gray-500 text-xs">{q.duration}</p>
                </div>
                <span className="text-slate-600 group-hover:text-emerald-400 transition-colors">→</span>
              </div>
            </button>
          ))}
        </div>

        {/* Lien secondaire */}
        <button
          onClick={onClose}
          className="w-full text-gray-500 hover:text-gray-400 text-sm transition-colors"
        >
          Plus tard
        </button>
      </div>
    </div>
  );
}
